export const contractDeployerAddress = '0x0000000000000000000000000000000000008006';
export const contract2FactoryAddress = '0x0000000000000000000000000000000000010000';
/** The address of the L1 `ETH` token. */
export const legacyEthAddress = '0x0000000000000000000000000000000000000000';
export const ethAddressInContracts = '0x0000000000000000000000000000000000000001';
/** The address of the base token. */
export const l2BaseTokenAddress = '0x000000000000000000000000000000000000800a';
export const l1MessengerAddress = '0x0000000000000000000000000000000000008008';
//# sourceMappingURL=address.js.map